import React from 'react'
import { ErrorBoundary, ErrorFallback } from '@/layout/ErrorBoundary'
import { Footer } from '@/organisms/Footer'
import { SiteNav } from '@/organisms/SiteNav'
import { BaseLayout } from '../BaseLayout'

interface BlogLayoutProps {
  children: React.ReactNode
  isDarkMode?: boolean
}

export const BlogLayout: React.FC<BlogLayoutProps> = ({ children, isDarkMode = true }) => {
  return (
    <BaseLayout isDarkMode={isDarkMode}>
      <SiteNav gradientBackground />
      <ErrorBoundary FallbackComponent={ErrorFallback}>{children}</ErrorBoundary>
      <Footer />
    </BaseLayout>
  )
}
